import Axios from "axios";
import store from "@/store";
import Vue from 'vue';
import router from "@/router";
import { AUTH_LOGOUT } from "@/store/actions/auth";

let tokenStr = localStorage.getItem("user-token");
export const apiClient = Axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  withCredentials: false, // This is the default  `http://10.28.103.132:8080`   http://10.28.103.77:8080
  //http://10.9.213.74:13380/ELGPortalService https://web1.uat.ktb:11001/ELGPortalService
  //http://10.28.103.67:8080  http://10.28.103.76:8080

  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
    "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
    "Content-Type": "application/json",
    Accept: "application/json",
    //Authorization: "Bearer "+store.getters.token
  },


});

// Add a request interceptor
apiClient.interceptors.request.use(function (config) {
  // Do something before request is sent

  config.headers={
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
    "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: "Bearer "+store.getters.token
  }


  return config;
}, function (error) {


  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
apiClient.interceptors.response.use(function (response) {

  // Do something with response data
  return response;
}, function (error) {
  // Do something with response error
console.log(error);
  if (error.response) {

    if(error.response.status===401){
      //Vue.swal('Session Timeout', 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'error');
      

      Vue.swal.fire({
        title: 'Session Timeout',
        text: "กรุณาเข้าสู่ระบบใหม่อีกครั้ง",
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง'
      }).then((result) => {
        if (result.value) {

          store.commit(AUTH_LOGOUT)
          localStorage.removeItem('user-token')
          localStorage.removeItem('user-name')
          localStorage.removeItem('beneTaxId')
          localStorage.removeItem('beneGroup')
          localStorage.removeItem('beneName')
    
          localStorage.removeItem('registerVerifyId')
          localStorage.removeItem('taxId')
          router.push("/");


          //   store.dispatch(AUTH_LOGOUT).then(() => {
          //   router.push("/");
          // });
        }
      })

    }
    // console.log(error.response.data);
    // console.log(error.response.status);
    // console.log(error.response.headers);
  }
  return Promise.reject(error);
});

